import observable from '@riotjs/observable';

function SmartsearchLoader() {
  observable(this)

  this.handler = () => { return 'didLoadTotalCount'; }

  this.loadTotalCount = (queries) => {
    let headers = new Headers()
    headers.append('Content-Type', 'text/json');
    if (__UDEDOKEI_ENV__ == 'staging') {
      headers.append('Authorization', __AUTH_KEY__);
    }
    let host ='//' + location.host
    // let host = 'http://localhost:3000'
    let endpointBase = host + '/watches/fetch_count/'
    let params = queries.filter(query => !!query[1] && query[1] != "undefined").map( query => query.join('=') ).join('&')
    let url = endpointBase + '?' + params
    fetch(url, {
      mode: __NODE_ENV__ == 'production' ? 'same-origin' : 'cors',
      headers: headers
    }).then( (res) => res.json()).then( (res) => {
      this.trigger(this.handler(), res)
    }).catch( (err) => {
      // console.log(err)
    })
  }
}

export default SmartsearchLoader
